import { PublicClientApplication } from "@azure/msal-browser";

import { getBeBaseUrl } from "../../setup/config/utils";
import { handleMsEntraLoginRedirect } from "../auth/completeMsEntraLogin";

const msalConfig = {
    auth: {
        // eslint-disable-next-line no-underscore-dangle
        clientId: `${window.__RUNTIME_CONFIG__?.CLIENT_ID}`,
        // eslint-disable-next-line no-underscore-dangle
        authority: `https://login.microsoftonline.com/${window.__RUNTIME_CONFIG__?.TENANT_ID}`,
        // eslint-disable-next-line no-underscore-dangle
        redirectUri: window.__RUNTIME_CONFIG__?.REDIRECT_URI,
        // Without this, MSAL automatically navigates back to whatever page called loginRedirect
        // (here, /login) once handleRedirectPromise resolves — cutting off handleMsEntraLoginRedirect
        // (see msalConfig bootstrap below) before it finishes writing the app's own tokens/cookies,
        // even though MSAL's own cache was already populated by that point.
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "localStorage",
        // Only needed as a fallback for browsers that lose sessionStorage across the full-page
        // redirect (old IE11/Safari). Leaving this on mirrors MSAL's temporary request state
        // (state/nonce, and retries from silent renewal) into cookies too, which pile up over a
        // long-lived session until they trip "400 Request Header Or Cookie Too Large".
        storeAuthStateInCookie: false,
    },
};

export const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

// loginRedirect (see ApaMSELoginPage) is a full-page navigation, so the response can only be
// picked up here at bootstrap — before the router's route loaders run, since they decide whether
// to bounce the user to /login based on whether MSAL already has an account cached.
await handleMsEntraLoginRedirect(msalInstance, getBeBaseUrl());
